import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const CustomDateTimePicker = ({ value, onChange }) => {
  const handleChange = date => {
    if (!date) {
      onChange(null);
      return;
    }
    onChange(moment(date));
  };

  return (
    <DatePicker
      selected={value ? value.toDate() : null}
      onChange={handleChange}
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={15}
      dateFormat="MMMM d, yyyy h:mm aa"
      className="ant-input"
      style={{
        width: '100%',
        padding: '4px 11px',
        borderRadius: '6px',
        border: '1px solid #d9d9d9',
        fontSize: '14px',
        lineHeight: '1.5715',
        color: 'rgba(0, 0, 0, 0.88)',
        backgroundColor: '#ffffff',
        backgroundImage: 'none',
        transition: 'all 0.2s',
        touchAction: 'manipulation',
      }}
      placeholderText="Select date and time"
      popperClassName="ant-picker-dropdown"
    />
  );
};

export default CustomDateTimePicker;
